import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from 'react-slick'
import { RealEstateDataPageComponentData } from 'types'

export const NextArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="next arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}
export const PrevArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="prev arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}

const settingsSlick: any = {
  dots: false,
  infinite: true,
  speed: 500,
  fade: false,
  slidesToShow: 4,
  centerPadding: 0,
  centerMode: true,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
}

const PartnersSlider = (props: RealEstateDataPageComponentData) => {
  const {
    title,
    arrayImages,
    titleElement,
    titleColor,
    titleHexa,
    animationStyle,
    backgroundColor,
    height,
    transitionTime,
  } = props

  const isBrowser = typeof window !== 'undefined'

  return (
    <section
      id="partners-slider"
      className="slider-partners a"
      style={backgroundColor ? { backgroundColor: backgroundColor } : {}}
    >
      <Container
        fluid
        className="p-y-config"
        style={{
          height: isBrowser
            ? screen.width < 992
              ? height?.mobile ?? 'auto'
              : height?.desktop ?? 'auto'
            : 'auto',
        }}
      >
        <Row className="w-100 text-center mb-3">
          <ElementHTML
            children={title ?? ''}
            elementType={titleElement ?? 'h2'}
            className={`${titleColor}`}
            style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
          />
        </Row>
        <Row
          className={
            'my-5 py-5 ' + (animationStyle ? ' justify-content-center align-items-center ' : '')
          }
        >
          {animationStyle ? (
            <Col lg={11}>
              <Slider {...settingsSlick}>
                {arrayImages?.map(({ image }, index) => (
                  <div className="div item-slide">
                    <img
                      key={index}
                      src={image}
                      className={'logo-flag img-slider px-4'}
                      alt={'logo-partner'}
                    />
                  </div>
                ))}
              </Slider>
            </Col>
          ) : (
            <div className="carousel-container">
              <div
                className="d-flex scrolling-wrapper"
                style={{
                  animation: `scroll ${transitionTime ?? '120s'} linear infinite`,
                }}
              >
                {[...(arrayImages ?? []), ...(arrayImages ?? [])]?.map(({ image }, index) => (
                  <img
                    key={index}
                    src={image}
                    className={'logo-flag'}
                    alt={'logo-partner'}
                  />
                ))}
              </div>
            </div>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default PartnersSlider
